import type { GridItem } from '~sharedLib'

export const BASE_GRID_SCHEMA: GridItem[] = [
	{ count: 4, type: 1 },
	{ count: 3, type: 1 },
	{ count: 3, type: 2 },
	{ count: 4, type: 2 },
	{ count: 3, type: 3 },
	{ count: 3, type: 4 },
	{ count: 2, type: 1 }
]
